import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeedbackComponent } from './components';
import { FeedbackContainerComponent } from './containers/feedback-container/feedback-container.component';
import { FeedbackService } from './services/feedback.service';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule, RadioModule, TextareaModule } from '@shared';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatDialogModule, RadioModule, ButtonModule, TextareaModule],
  declarations: [FeedbackContainerComponent, FeedbackComponent],
  providers: [FeedbackService],
})
export class FeedbackModule {
  constructor(private fb: FeedbackService) {}
}
